import React, {useEffect, useState} from 'react';
import {
    Paper, Table, TableBody, TableCell, TableContainer,
    TablePagination, TableRow, LinearProgress
} from '@material-ui/core';

import {coreStyle, EnhancedTableHead} from "../../styles/config";
import AddBuyer from "./add";
import DeleteButton from "../../utils/delete";
import {parseQueryParams} from "../../utils/helpers";
import Resource from "../../crud/resource";
import Search from "../../widgets/Search";
import {useSelector} from "react-redux";
import {withRouter} from "react-router-dom";
import Translate from "../../utils/utils";

function Buyer(props) {
    const user = useSelector(store => store.auth.user);
    const {location: {search}, history} = props;
    const queryParams = parseQueryParams(search);
    const [page, setPage] = React.useState(queryParams.page);
    const perPage = queryParams.perPage;
    const [buyers, setBuyers] = useState([]);
    const initialValues = {name: "", email: "", phone: "", active: '1', rfh_number: '', contact: '', parent_id: null,secondary_email:""};
    const [buyer, setBuyer] = useState(initialValues);
    const [buyerParents, setBuyerParents] = useState([]);
    const resource = new Resource('buyer');
    const [name, setName] = useState(queryParams.name);
    const [isLoading, setIsLoading] = useState(true);
    const [pagination, setPagination] = useState({
        total: 0,
        current_page: queryParams.page,
        per_page: queryParams.perPage,
    });

    const buyerParentResource = new Resource('buyerParent');

    const removeItemInListing = (id) => {
        const remaining = buyers.filter((item) => item.id !== id);
        const total = remaining.length;
        setPagination(Object.assign(pagination, {total: pagination.total - 1, 'to': total}));
        setBuyers(remaining);
    };

    const headCells = [

        {id: 'rfh_number', numeric: true, disablePadding: false, label: <Translate id={"TABLE.ID"}/>},
        {id: 'name', numeric: false, disablePadding: false, label: <Translate id={"TABLE.NAME"}/>},
        {id: 'phone', numeric: true, disablePadding: false, label: <Translate id={"TABLE.PHONE"}/>},
        {id: 'contact', numeric: true, disablePadding: false, label: <Translate id={"TABLE.CONTACT"}/>},
        {id: 'status', numeric: true, disablePadding: false, label: <Translate id={"TABLE.STATUS"}/>},
        {id: 'date', numeric: true, disablePadding: false, label: <Translate id={"TABLE.DATE"}/>},
        {id: 'actions', numeric: true, disablePadding: false, label: <Translate id={"TABLE.ACTIONS"}/>},
    ];

    useEffect(() => {

        const index = () => {
            setIsLoading(true);
            const resource = new Resource('buyer');
            resource.index({
                perPage,
                page,
                name
            })
                .then(response => {
                    const {data: {data = {data: []}}} = response;
                    const paginationData = data;
                    setBuyers(paginationData.data);
                    setPagination(paginationData);
                    setIsLoading(false);
                }).catch(err => {
                setIsLoading(false);
            })

            buyerParentResource.index({perPage: 300}).then(response => {
                const {data: {data = {data: []}}} = response;
                setBuyerParents(data.data);
                setIsLoading(false);
            }).catch(err => {
                setIsLoading(false);
            });
        };
        index();
    }, [page, perPage]);

    const handleCreate = (buyer) => {
        const buyersList = [buyer, ...buyers];
        setBuyers(buyersList);
    };

    const handleUpdate = (buyer) => {
        const buyersList = buyers.map(item => {
            if (item.id === buyer.id) {
                return buyer;
            }
            return item;
        });
        setBuyers(buyersList);
    };

    const onType = (e) => {
        const {target: {value}} = e;
        setName(value);

    };

    const onClearSearch = () => {
        history.push(`?page=1&perPage=${perPage}`);
    };

    const onSearch = () => {
        history.push(`?page=1&perPage=${perPage}&name=${name}`);
    };

    const handleChangePage = (e, page) => {
        setPage(++page);
        return history.push(`?page=${page}&perPage=${perPage}&name=${name}`);
    };

    const handlePerPageChange = (perPage) => {
        history.push(`?page=1&perPage=${perPage}&name=${name}`);
    };

    return (
        <div className={coreStyle.root}>
            <div className="add-user__button">
                <AddBuyer handleCreate={handleCreate} resource={resource} handleUpdate={handleUpdate}
                          onCloseModal={() => setBuyer(initialValues)} initialValues={buyer} key={buyer.id}
                          buyerParents={buyerParents}/>
            </div>
            <Search onType={onType} onSubmit={onSearch} onClear={onClearSearch} value={queryParams.name}/>

            {isLoading && <LinearProgress color="secondary"/>}
            <Paper className={coreStyle.paper}>
                <TableContainer>
                    <Table
                        className={coreStyle.table}
                        aria-labelledby="tableTitle"
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            headCells={headCells}
                            rowCount={buyers.length}
                            isLoading={isLoading}
                        />
                        <TableBody>
                            {buyers.map(buyer => {

                                buyer.getStatus = () => {
                                    return buyer.active === '1' ? 'ACTIVE' : 'INACTIVE';
                                };

                                return (
                                    <TableRow
                                        hover
                                        role="checkbox"
                                        aria-checked={buyer.selected}
                                        tabIndex={-1}
                                        key={buyer.id}
                                        selected={buyer.selected}
                                    >
                                        <TableCell>{buyer.rfh_number}</TableCell>
                                        <TableCell component="th" scope="row">
                                            {buyer.name}
                                        </TableCell>
                                        <TableCell>{buyer.phone}</TableCell>
                                        <TableCell>{buyer.contact}</TableCell>
                                        <TableCell>
                                            <button
                                                className={` ${buyer.getStatus() !== 'ACTIVE' ? 'text-danger' : ''} button-status `}>
                                                {<Translate id={`TABLE.STATUS.${buyer.getStatus()}`}/>}
                                            </button>
                                        </TableCell>
                                        <TableCell>{buyer.created_at}</TableCell>
                                        <TableCell>
                                            <button className='button-edit-delete' onClick={() => setBuyer(buyer)}>
                                                <Translate id={"TABLE.ACTIONS.EDIT"}/>
                                            </button>

                                            {user.role.name !== 'INSPECTOR' &&
                                            <>
                                                <em className='actions-separator'>|</em>
                                                <DeleteButton
                                                    module={`buyer`}
                                                    itemId={buyer.id}
                                                    itemName={buyer.name}
                                                    removeItemInListing={removeItemInListing}
                                                    dropdownItem={true}
                                                />
                                            </>
                                            }
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[15, 50, 100]} labelRowsPerPage={<Translate id="TABLE.ROWS_PER_PAGE"/>}
                    component="div"
                    count={pagination.total}
                    rowsPerPage={pagination.per_page}
                    page={pagination.current_page - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={(e) => handlePerPageChange(e.target.value)}
                />
            </Paper>
        </div>
    );
}

export default withRouter(Buyer);
